export const EquipmentSizeList = [
  { id: "2", name: "2" },
  { id: "3", name: "3" },
  { id: "5", name: "5" },
  { id: "7", name: "7" },
  { id: "8", name: "8" },
  { id: "10", name: "10" },
  { id: "11", name: "11" },
  { id: "12", name: "12" },
  { id: "14", name: "14" },
  { id: "20", name: "20" },
  { id: "45", name: "45" },
  { id: "60", name: "60" },
  { id: "90", name: "90" },
  { id: "110", name: "110" },
  { id: "120", name: "120" },
  { id: "180", name: "180" },
  { id: "240", name: "240" },
  { id: "330", name: "330" },
  { id: "340", name: "340" },
  { id: "360", name: "360" },
  { id: "380", name: "380" },
  { id: "500", name: "500" },
  { id: "600", name: "600" },
  { id: "610", name: "610" },
  { id: "660", name: "660" },
  { id: "700", name: "700" },
  { id: "770", name: "770" },
  { id: "900", name: "900" },
  { id: "1000", name: "1000" },
  { id: "1100", name: "1100" },
  { id: "1400", name: "1400" },
  { id: "1700", name: "1700" },
];
